export default {
  defaultStepLabel: "Step",
  stepStatus: {
    active: "in progress",
    completed: "completed",
    pending: "incomplete"
  }
};